export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          <div className="lg:col-span-2 relative">
            <div className="text-gray-100 text-[240px] font-serif leading-none select-none opacity-30">
              "
            </div>
          </div>

          <div className="lg:col-span-3 lg:pl-20">
            <p className="text-sm font-semibold text-blue-600 uppercase tracking-widest mb-6">
              A A D LIMA VERDE LTDA
            </p>
            <h2 className="text-5xl font-bold font-serif text-gray-900 mb-8 leading-tight">
              Committed to Your Privacy
            </h2>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed max-w-2xl">
              <p>
                At A A D LIMA VERDE LTDA, we believe that privacy is a fundamental right. Our mission is to provide individuals and businesses with the tools they need to protect their digital freedom and maintain complete control over their online presence.
              </p>
              <p>
                Founded with a vision to make internet security accessible to everyone, we have developed a VPN solution that combines cutting-edge encryption technology with user-friendly design. Our team of security experts works tirelessly to ensure that your data remains private and your connection stays secure, no matter where you are in the world.
              </p>
              <p>
                We operate under a strict no-logs policy, meaning we never track, collect, or share your browsing data. Your trust is our most valuable asset, and we are committed to maintaining the highest standards of transparency and security in everything we do. Join thousands of users who have chosen to take control of their online privacy with our VPN solution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
